import Typography from '@material-ui/core/Typography'
import React from 'react'

export default function Ultimate() {
  return (
    <Typography component="div">
      <h2>How to Yang Everyone!!</h2>
      <p>
        The best way to market Yang is by repeating the message to people, so
        you'll just need to say the script on the card and hand it over. The
        card has an easy pathway to FULL YangGang conversion! By handing over
        the card, it reminds people what you've just said!{' '}
      </p>
      <p>
        <strong>Steps on Yanging a cashier: </strong>
      </p>
      <ol>
        <li>Have you heard of Andrew Yang?</li>
        <li>
          Have you noticed stores are closing because of Amazon? (Usually Yes)
        </li>
        <li>Did you know they paid 0 in taxes?</li>
        <li>
          There's a lot of job loss because of them, they use technology and
          automation to achieve that (Usually they nod their head)
        </li>
        <li>
          There's a proposal to tax Amazon, Facebook, Google, etc. and pay every
          adult $1,000 a month, it's called Universal Basic Income
        </li>
        <li>I'm sure you have more questions, so check out YangAnswers.com</li>
        <li>
          And when you get a chance, check out Joe Rogan's interview with Andrew
          Yang on Youtube (show them the back of the card)
        </li>
        <li>Hand them the card (Usually they'll say thanks!)</li>
      </ol>
      <p>Great job! Pathway to full YangGang conversion achieved!</p>
      <p>
        <strong>How to guide here: </strong>{' '}
        <a href="https://www.reddit.com/r/YangForPresidentHQ/comments/e45eku/the_ultimate_yang_business_card_yang_people_in/">
          How to Yang in 15 seconds flat
        </a>
      </p>
      <p>
        <strong>Download PSD here:</strong>{' '}
        <a href="http://yanganswers.com/UltimateYangBusinessCard.psd">
          http://yanganswers.com/UltimateYangBusinessCard.psd
        </a>
      </p>
    </Typography>
  )
}
